import { render, staticRenderFns } from "./ContactCreationModal.vue?vue&type=template&id=797cff79&"
import script from "./ContactCreationModal.vue?vue&type=script&lang=js&"
export * from "./ContactCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports